var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isResponse)?_c('vue-renderer',{attrs:{"result":_vm.items},on:{"renderer-event":function($event){return _vm.getCard($event)}}}):_vm._e(),_c('div',{on:{"click":function($event){return _vm.changeColor($event)}}},[(!_vm.isResponse)?_vm._t("default"):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }